import { Controller, useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

const FIELD_NAME = 'units'

interface Props extends WithFieldPermissionsProps, WithCustomizationFieldsProps {
  setIsCalculatingDistance?: (loading: boolean) => void
}

const UnitsField = ({ isFieldReadOnly, isFieldMandatory, customizationFields }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const unitOptions = fieldOptions('mileage', 'units', customizationFields)

  return (
    <Box width="full">
      <Controller
        name={FIELD_NAME}
        control={control}
        render={({ field }) => (
          <SelectField
            label={i18n.t('expenses_v2.forms.fields.units.label')}
            options={unitOptions}
            value={field.value}
            onChange={(value) => {
              field.onChange(value)
            }}
            error={castError(errors?.units)}
            readonly={isFieldReadOnly}
            mandatory={isFieldMandatory}
          />
        )}
      />
    </Box>
  )
}

export default withCustomizationFields(withFieldPermissions(UnitsField, 'units'))
